import ajax from './ajax';

export function fetchAssets() {
  return ajax('/assets?per-page=1000&page=1&fields=id,category,name,file_name,file_type,file_size');
}
